import { ParticipantProfile } from "../../models/entities/participant.model";
import * as dataStorageService from "./session.service";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
export const SESSION_KEY = "starlight-user";
export const TOKEN_KEY = "starlight-token";

/**
 * SESSION
 */

// Session > DELETE
export const deleteSession = (): void => {
	dataStorageService.deleteItem(SESSION_KEY);
	deleteCookieToken();
};

// Session > SET
export const setSession = (userData: ParticipantProfile, token: string): void => {
	dataStorageService.setItem(SESSION_KEY, userData);
	setCookieToken(token);
};

// Session storage > SET User
export const setLocalStorageUser = (userData: ParticipantProfile): void => {
	dataStorageService.setItem(SESSION_KEY, userData);
};

// Session storage > GET User
export const getLocalStorageUser = (): ParticipantProfile =>
	dataStorageService.getItem(SESSION_KEY);

/**
 * COOKIE
 */

// Cookie > DELETE Token
export const deleteCookieToken = (): void => {
	cookies.remove(TOKEN_KEY, { domain: cookieHostname, path: "/" });
};

const cookieHostname = window.location.hostname.startsWith(".")
	? window.location.hostname.substring(1)
	: window.location.hostname;

// Cookie > SET expiration date (8 hours)
const setCookieExpirationDate = (): Date => {
	const expirationDate: Date = new Date();
	expirationDate.setHours(expirationDate.getHours() + 9);
	return expirationDate;
};

// Cookie > SET Token
export const setCookieToken = (token: string): void =>
	cookies.set(TOKEN_KEY, token, {
		expires: setCookieExpirationDate(),
		domain: cookieHostname,
		path: "/",
	});

// Cookie > GET Token
export const getCookieToken = (): string => cookies.get(TOKEN_KEY);

// Cookie > Check token validity
export const validCookieToken = (): boolean => !!cookies.get(TOKEN_KEY);

// Cookie > SET Twilio Token
export const setTwilioCookieToken = (token: string): void =>
	cookies.set("k-t-token", token, {
		expires: setCookieExpirationDate(),
		domain: cookieHostname,
		path: "/",
	});

// Cookie > GET Twilio Token
export const getTwilioCookieToken = (): string => cookies.get("k-t-token");

// Cookie > Check Twilio Token validity
export const validTwilioCookieToken = (): boolean => !!cookies.get("k-t-token");
